export interface IAddCreditRequest {
    MemberID: number;
    Amount: number;
    Description: string;
}

export class AddCreditRequest implements IAddCreditRequest {
    MemberID: number;
    Amount: number;
    Description: string;
}
